import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatExpansionPanel, MatDialog } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { DataSharingService } from 'shared/services/data-sharing/data-sharing.service';
import { AlertPopupService } from 'shared/services/SS-Alert/alert-popup.service';
import { SsInventoryService } from 'shared/services/SS-Inventory/ss-inventory.service';
import { environment } from 'environments/environment';
import { ViewScheduleComponent } from '../view-schedule/view-schedule.component';
declare var Snap: any;

@Component({
  selector: 'app-choose-seat-selection',
  templateUrl: './choose-seat-selection.component.html',
  styleUrls: ['./choose-seat-selection.component.css']
})
export class ChooseSeatSelectionComponent implements OnInit {
  loading: boolean;
  selectionForm: FormGroup;
  plans: any = [];
  seats: any = [];
  sections: any = [];
  schedules: any = [];
  previousSelectedId: string;
  eventName: string;
  team: any;
  buttonLabels = [
    'Me + 1 Other',
    'Me + 2 Others',
    'Me + 3 Others'
  ];
  imageURL: string = environment.URL_TEAM_IMAGES;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private data: DataSharingService,
    private dialog: MatDialog,
    private inventoryService: SsInventoryService,
    private alertService: AlertPopupService) {
    this.route.queryParams.subscribe(params => { this.eventName = params.eventName; });
  }

  ngOnInit() {
    this.loading = true;
    this.getPlan();
    this.getSection();
    this.getSchedule();
    this.selectionForm = new FormGroup({
      plan: new FormControl(''),
      seat: new FormControl(''),
      section: new FormControl(''),
      schedule: new FormControl(''),
    });
    this.inventoryService.getPackagedata(this.eventName).subscribe(res => {
      this.team = res.teams;
      Snap.load('/assets/images/stadiums/' + this.team.stadium_svg, this.onSVGLoaded);
      this.getSeats();
      this.loading = false;
    }, err => {
      this.loading = false;
      this.alertService.errorAlertWithResult(err.error.message, 'Go Back', '/new-group');
    });
  }

  chooseData(value, controlName, matExpansionPanel: MatExpansionPanel, mapSectorId) {
    matExpansionPanel.close();
    this.selectionForm.get(controlName).setValue(value);
    if (mapSectorId) {
      const id = mapSectorId.match(/(\d+)/);
      this.unselectSection(id[0]);
      const s = Snap('#section' + id[0]);
      if (s) {
        s.node.style.fill = '#3B99FB';
      }
    }
  }

  viewSchedule() {
    const dialogRef = this.dialog.open(ViewScheduleComponent, {
      data: {
        eventName: this.team.event_name,
        teamImage: this.team.team_thumb_img,
        teamName: this.team.team_name_full,
        teamDescription: this.team.description,
        vendorId: this.team.vendor_id_fk
      },
      width: '70%',
    });
  }

  unselectSection(id) {
    if (this.previousSelectedId) {
      const s = Snap('#section' + this.previousSelectedId);
      if (s) {
        s.node.style.fill = null;
      }
    }
    this.previousSelectedId = id;
  }

  onSVGLoaded(data) {
    const s = Snap('#map');
    s.append(data);
  }

  getPlan() {
    this.plans = [
      {
        'packageId': '9424',
        'code': '19VOUCHFLEX10',
        'publicDescription': '2019 Voucher 10 Pack',
        'type': 'PACKAGE',
        'packageLists': [
          {
            'refSet': 'packageLists',
            'refKey': '9421',
            'refIndex': 0
          }
        ]
      },
      {
        'packageId': '9637',
        'code': '20RSFULL',
        'publicDescription': '2020 Full Season',
        'type': 'PACKAGE',
        'packageLists': [
          {
            'refSet': 'packageLists',
            'refKey': '9631',
            'refIndex': 1
          }
        ]
      },
      {
        'packageId': '9638',
        'code': '20RSFULL+PARK',
        'publicDescription': '2020 Full Season plus Parking',
        'type': 'PACKAGE',
        'packageLists': [
          {
            'refSet': 'packageLists',
            'refKey': '9631',
            'refIndex': 1
          },
          {
            'refSet': 'packageLists',
            'refKey': '9636',
            'refIndex': 2
          }
        ]
      },
      {
        'packageId': '9639',
        'code': '20RSHALFA',
        'publicDescription': '2020 Half A Games',
        'type': 'PACKAGE',
        'packageLists': [
          {
            'refSet': 'packageLists',
            'refKey': '9633',
            'refIndex': 3
          }
        ]
      },
      {
        'packageId': '9640',
        'code': '20RSHALFB',
        'publicDescription': '2020 Half B Games',
        'type': 'PACKAGE',
        'packageLists': [
          {
            'refSet': 'packageLists',
            'refKey': '9635',
            'refIndex': 4
          }
        ]
      },
      {
        'packageId': '9642',
        'code': '20PICK20',
        'publicDescription': '2020 Pick 20 Games',
        'type': 'PACKAGE',
        'packageLists': [
          {
            'refSet': 'packageLists',
            'refKey': '9641',
            'refIndex': 5
          }
        ]
      },
      {
        'packageId': '9646',
        'code': '20VOUCHFLEX10',
        'publicDescription': '2020 Voucher 10 Pack',
        'type': 'PACKAGE',
        'packageLists': [
          {
            'refSet': 'packageLists',
            'refKey': '9643',
            'refIndex': 6
          }
        ]
      }
    ];
  }

  getSeats() {
    this.seats = [
      {
        seat_count_txt: '1 Seat',
        seat_count_int: 1
      },
      {
        seat_count_txt: '2 Seats',
        seat_count_int: 2
      },
      {
        seat_count_txt: '3 Seats',
        seat_count_int: 3
      },
      {
        seat_count_txt: '4 Seats',
        seat_count_int: 4
      },
      {
        seat_count_txt: '5 Seats',
        seat_count_int: 5
      },
      {
        seat_count_txt: '6 Seats',
        seat_count_int: 6
      },
      {
        seat_count_txt: '7 Seats',
        seat_count_int: 7
      },
      {
        seat_count_txt: '8 Seats',
        seat_count_int: 8
      },
      {
        seat_count_txt: '9 Seats',
        seat_count_int: 9
      }];
  }

  getSection() {
    this.sections = [
      {
        'id': '5877',
        'publicDescription': 'Dugout Club 113',
        'code': 'DC113',
        'description': 'Dugout Club 113'
      },
      {
        'id': '5907',
        'publicDescription': 'Dugout Club 115',
        'code': 'DC115',
        'description': 'Dugout Club 115'
      },
      {
        'id': '5746',
        'publicDescription': 'Dugout Club 117',
        'code': 'DC117',
        'description': 'Dugout Club 117'
      },
      {
        'id': '5810',
        'publicDescription': 'Dugout Club 119',
        'code': 'DC119',
        'description': 'Dugout Club 119'
      },
      {
        'id': '5919',
        'publicDescription': 'Dugout Club 121',
        'code': 'DC121',
        'description': 'Dugout Club 121'
      },
      {
        'id': '5946',
        'publicDescription': 'Premium Field Club 113',
        'code': 'PFC113',
        'description': 'Premium Field Club 113'
      },
      {
        'id': '5966',
        'publicDescription': 'Premium Field Club 115',
        'code': 'PFC115',
        'description': 'Premium Field Club 115'
      },
      {
        'id': '5947',
        'publicDescription': 'Premium Field Club 112',
        'code': 'PFC112',
        'description': 'Premium Field Club 112'
      },
      {
        'id': '5964',
        'publicDescription': 'Premium Field Club 117',
        'code': 'PFC117',
        'description': 'Premium Field Club 117'
      },
      {
        'id': '5940',
        'publicDescription': 'Premium Field Club 119',
        'code': 'PFC119',
        'description': 'Premium Field Club 119'
      },
      {
        'id': '5718',
        'publicDescription': 'Premium Field Club 110',
        'code': 'PFC110',
        'description': 'Premium Field Club 110'
      },
      {
        'id': '5938',
        'publicDescription': 'Premium Field Club 121',
        'code': 'PFC121',
        'description': 'Premium Field Club 121'
      },
      {
        'id': '5717',
        'publicDescription': 'Premium Field Club 109',
        'code': 'PFC109',
        'description': 'Premium Field Club 109'
      },
      {
        'id': '5965',
        'publicDescription': 'Premium Field Club 122',
        'code': 'PFC122',
        'description': 'Premium Field Club 122'
      },
      {
        'id': '5720',
        'publicDescription': 'Premium Field Club 108',
        'code': 'PFC108',
        'description': 'Premium Field Club 108'
      },
      {
        'id': '5941',
        'publicDescription': 'Premium Field Club 123',
        'code': 'PFC123',
        'description': 'Premium Field Club 123'
      },
      {
        'id': '5937',
        'publicDescription': 'Premium Field Club 107',
        'code': 'PFC107',
        'description': 'Premium Field Club 107'
      },
      {
        'id': '5715',
        'publicDescription': 'Premium Field Club 124',
        'code': 'PFC124',
        'description': 'Premium Field Club 124'
      },
      {
        'id': '5729',
        'publicDescription': 'Field Club 113',
        'code': 'FC113',
        'description': 'Field Club 113'
      },
      {
        'id': '5750',
        'publicDescription': 'Field Club 115',
        'code': 'FC115',
        'description': 'Field Club 115'
      },
      {
        'id': '5728',
        'publicDescription': 'Field Club 112',
        'code': 'FC112',
        'description': 'Field Club 112'
      },
      {
        'id': '5900',
        'publicDescription': 'Field Club 117',
        'code': 'FC117',
        'description': 'Field Club 117'
      },
      {
        'id': '5825',
        'publicDescription': 'Field Club 119',
        'code': 'FC119',
        'description': 'Field Club 119'
      },
      {
        'id': '5833',
        'publicDescription': 'Field Club 110',
        'code': 'FC110',
        'description': 'Field Club 110'
      },
      {
        'id': '5696',
        'publicDescription': 'Field Club 121',
        'code': 'FC121',
        'description': 'Field Club 121'
      },
      {
        'id': '5932',
        'publicDescription': 'Field Club 109',
        'code': 'FC109',
        'description': 'Field Club 109'
      },
      {
        'id': '5804',
        'publicDescription': 'Field Club 122',
        'code': 'FC122',
        'description': 'Field Club 122'
      },
      {
        'id': '5860',
        'publicDescription': 'Field Club 108',
        'code': 'FC108',
        'description': 'Field Club 108'
      },
      {
        'id': '5813',
        'publicDescription': 'Field Club 123',
        'code': 'FC123',
        'description': 'Field Club 123'
      },
      {
        'id': '5853',
        'publicDescription': 'Field Club 107',
        'code': 'FC107',
        'description': 'Field Club 107'
      },
      {
        'id': '5788',
        'publicDescription': 'Club Level 215',
        'code': 'CL215',
        'description': 'Club Level 215'
      },
      {
        'id': '5757',
        'publicDescription': 'Club Level 216',
        'code': 'CL216',
        'description': 'Club Level 216'
      },
      {
        'id': '5776',
        'publicDescription': 'Club Level 214',
        'code': 'CL214',
        'description': 'Club Level 214'
      },
      {
        'id': '5702',
        'publicDescription': 'Club Level 218',
        'code': 'CL218',
        'description': 'Club Level 218'
      },
      {
        'id': '5928',
        'publicDescription': 'Club Level 213',
        'code': 'CL213',
        'description': 'Club Level 213'
      },
      {
        'id': '5862',
        'publicDescription': 'Club Level 212',
        'code': 'CL212',
        'description': 'Club Level 212'
      },
      {
        'id': '5927',
        'publicDescription': 'Club Level 220',
        'code': 'CL220',
        'description': 'Club Level 220'
      },
      {
        'id': '5774',
        'publicDescription': 'Club Level 221',
        'code': 'CL221',
        'description': 'Club Level 221'
      },
      {
        'id': '5791',
        'publicDescription': 'Club Level 211',
        'code': 'CL211',
        'description': 'Club Level 211'
      },
      {
        'id': '5869',
        'publicDescription': 'Club Level 222',
        'code': 'CL222',
        'description': 'Club Level 222'
      },
      {
        'id': '5834',
        'publicDescription': 'Club Level 210',
        'code': 'CL210',
        'description': 'Club Level 210'
      },
      {
        'id': '5827',
        'publicDescription': 'Club Level 223',
        'code': 'CL223',
        'description': 'Club Level 223'
      },
      {
        'id': '5960',
        'publicDescription': 'Club Level 209',
        'code': 'CL209',
        'description': 'Club Level 209'
      },
      {
        'id': '5806',
        'publicDescription': 'Club Level 224',
        'code': 'CL224',
        'description': 'Club Level 224'
      },
      {
        'id': '5956',
        'publicDescription': 'Club Level 208',
        'code': 'CL208',
        'description': 'Club Level 208'
      },
      {
        'id': '5778',
        'publicDescription': 'Club Level 225',
        'code': 'CL225',
        'description': 'Club Level 225'
      },
      {
        'id': '5787',
        'publicDescription': 'Club Level 207',
        'code': 'CL207',
        'description': 'Club Level 207'
      },
      {
        'id': '5894',
        'publicDescription': 'Club Level 226',
        'code': 'CL226',
        'description': 'Club Level 226'
      },
      {
        'id': '5719',
        'publicDescription': 'Club Level 227',
        'code': 'CL227',
        'description': 'Club Level 227'
      },
      {
        'id': '5952',
        'publicDescription': 'Club Level 205',
        'code': 'CL205',
        'description': 'Club Level 205'
      },
      {
        'id': '5832',
        'publicDescription': 'Club Level 228',
        'code': 'CL228',
        'description': 'Club Level 228'
      },
      {
        'id': '5698',
        'publicDescription': 'Club Level 204',
        'code': 'CL204',
        'description': 'Club Level 204'
      },
      {
        'id': '5779',
        'publicDescription': 'Club Level 229',
        'code': 'CL229',
        'description': 'Club Level 229'
      },
      {
        'id': '5924',
        'publicDescription': 'Club Level 203',
        'code': 'CL203',
        'description': 'Club Level 203'
      },
      {
        'id': '5799',
        'publicDescription': 'Club Level 230',
        'code': 'CL230',
        'description': 'Club Level 230'
      },
      {
        'id': '5734',
        'publicDescription': 'Club Level 202',
        'code': 'CL202',
        'description': 'Club Level 202'
      },
      {
        'id': '5961',
        'publicDescription': 'Club Level 231',
        'code': 'CL231',
        'description': 'Club Level 231'
      },
      {
        'id': '5801',
        'publicDescription': 'Club Level 232',
        'code': 'CL232',
        'description': 'Club Level 232'
      },
      {
        'id': '5879',
        'publicDescription': 'Club Level 233',
        'code': 'CL233',
        'description': 'Club Level 233'
      },
      {
        'id': '5807',
        'publicDescription': 'Club Level 234',
        'code': 'CL234',
        'description': 'Club Level 234'
      },
      {
        'id': '5845',
        'publicDescription': 'Premium Lower Box 115',
        'code': 'PLB115',
        'description': 'Premium Lower Box 115'
      },
      {
        'id': '5852',
        'publicDescription': 'Premium Lower Box 116',
        'code': 'PLB116',
        'description': 'Premium Lower Box 116'
      },
      {
        'id': '5886',
        'publicDescription': 'Premium Lower Box 117',
        'code': 'PLB117',
        'description': 'Premium Lower Box 117'
      },
      {
        'id': '5846',
        'publicDescription': 'Premium Lower Box 114',
        'code': 'PLB114',
        'description': 'Premium Lower Box 114'
      },
      {
        'id': '5949',
        'publicDescription': 'Premium Lower Box 113',
        'code': 'PLB113',
        'description': 'Premium Lower Box 113'
      },
      {
        'id': '5850',
        'publicDescription': 'Premium Lower Box 118',
        'code': 'PLB118',
        'description': 'Premium Lower Box 118'
      },
      {
        'id': '5948',
        'publicDescription': 'Premium Lower Box 112',
        'code': 'PLB112',
        'description': 'Premium Lower Box 112'
      },
      {
        'id': '5849',
        'publicDescription': 'Premium Lower Box 119',
        'code': 'PLB119',
        'description': 'Premium Lower Box 119'
      },
      {
        'id': '5943',
        'publicDescription': 'Premium Lower Box 110',
        'code': 'PLB110',
        'description': 'Premium Lower Box 110'
      },
      {
        'id': '5881',
        'publicDescription': 'Premium Lower Box 121',
        'code': 'PLB121',
        'description': 'Premium Lower Box 121'
      },
      {
        'id': '5942',
        'publicDescription': 'Premium Lower Box 109',
        'code': 'PLB109',
        'description': 'Premium Lower Box 109'
      },
      {
        'id': '5859',
        'publicDescription': 'Premium Lower Box 122',
        'code': 'PLB122',
        'description': 'Premium Lower Box 122'
      },
      {
        'id': '5945',
        'publicDescription': 'Premium Lower Box 108',
        'code': 'PLB108',
        'description': 'Premium Lower Box 108'
      },
      {
        'id': '5714',
        'publicDescription': 'Premium Lower Box 123',
        'code': 'PLB123',
        'description': 'Premium Lower Box 123'
      },
      {
        'id': '5711',
        'publicDescription': 'Premium Lower Box 124',
        'code': 'PLB124',
        'description': 'Premium Lower Box 124'
      },
      {
        'id': '5888',
        'publicDescription': 'Premium Lower Box 106',
        'code': 'PLB106',
        'description': 'Premium Lower Box 106'
      },
      {
        'id': '5716',
        'publicDescription': 'Premium Lower Box 125',
        'code': 'PLB125',
        'description': 'Premium Lower Box 125'
      },
      {
        'id': '5887',
        'publicDescription': 'Premium Lower Box 105',
        'code': 'PLB105',
        'description': 'Premium Lower Box 105'
      },
      {
        'id': '5713',
        'publicDescription': 'Premium Lower Box 126',
        'code': 'PLB126',
        'description': 'Premium Lower Box 126'
      },
      {
        'id': '5925',
        'publicDescription': 'Lower Box 127',
        'code': 'LB127',
        'description': 'Lower Box 127'
      },
      {
        'id': '5934',
        'publicDescription': 'Lower Box 115',
        'code': 'LB115',
        'description': 'Lower Box 115'
      },
      {
        'id': '5733',
        'publicDescription': 'Lower Box 116',
        'code': 'LB116',
        'description': 'Lower Box 116'
      },
      {
        'id': '5890',
        'publicDescription': 'Lower Box 113',
        'code': 'LB113',
        'description': 'Lower Box 113'
      },
      {
        'id': '5817',
        'publicDescription': 'Lower Box 114',
        'code': 'LB114',
        'description': 'Lower Box 114'
      },
      {
        'id': '5772',
        'publicDescription': 'Lower Box 117',
        'code': 'LB117',
        'description': 'Lower Box 117'
      },
      {
        'id': '5763',
        'publicDescription': 'Lower Box 118',
        'code': 'LB118',
        'description': 'Lower Box 118'
      },
      {
        'id': '5805',
        'publicDescription': 'Lower Box 112',
        'code': 'LB112',
        'description': 'Lower Box 112'
      },
      {
        'id': '5914',
        'publicDescription': 'Lower Box 119',
        'code': 'LB119',
        'description': 'Lower Box 119'
      },
      {
        'id': '5815',
        'publicDescription': 'Lower Box 110',
        'code': 'LB110',
        'description': 'Lower Box 110'
      },
      {
        'id': '5829',
        'publicDescription': 'Lower Box 121',
        'code': 'LB121',
        'description': 'Lower Box 121'
      },
      {
        'id': '5712',
        'publicDescription': 'Lower Box 109',
        'code': 'LB109',
        'description': 'Lower Box 109'
      },
      {
        'id': '5786',
        'publicDescription': 'Lower Box 122',
        'code': 'LB122',
        'description': 'Lower Box 122'
      },
      {
        'id': '5865',
        'publicDescription': 'Lower Box 108',
        'code': 'LB108',
        'description': 'Lower Box 108'
      },
      {
        'id': '5867',
        'publicDescription': 'Lower Box 123',
        'code': 'LB123',
        'description': 'Lower Box 123'
      },
      {
        'id': '5893',
        'publicDescription': 'Lower Box 124',
        'code': 'LB124',
        'description': 'Lower Box 124'
      },
      {
        'id': '5739',
        'publicDescription': 'Lower Box 107',
        'code': 'LB107',
        'description': 'Lower Box 107'
      },
      {
        'id': '5898',
        'publicDescription': 'Lower Box 125',
        'code': 'LB125',
        'description': 'Lower Box 125'
      },
      {
        'id': '5754',
        'publicDescription': 'Lower Box 106',
        'code': 'LB106',
        'description': 'Lower Box 106'
      },
      {
        'id': '5921',
        'publicDescription': 'Lower Box 126',
        'code': 'LB126',
        'description': 'Lower Box 126'
      },
      {
        'id': '5840',
        'publicDescription': 'Lower Box 105',
        'code': 'LB105',
        'description': 'Lower Box 105'
      },
      {
        'id': '5905',
        'publicDescription': 'Lower Box 104',
        'code': 'LB104',
        'description': 'Lower Box 104'
      },
      {
        'id': '5753',
        'publicDescription': 'Lower Box 128',
        'code': 'LB128',
        'description': 'Lower Box 128'
      },
      {
        'id': '5796',
        'publicDescription': 'Lower Box 103',
        'code': 'LB103',
        'description': 'Lower Box 103'
      },
      {
        'id': '5730',
        'publicDescription': 'Lower Box 129',
        'code': 'LB129',
        'description': 'Lower Box 129'
      },
      {
        'id': '5736',
        'publicDescription': 'Lower Box 102',
        'code': 'LB102',
        'description': 'Lower Box 102'
      },
      {
        'id': '5705',
        'publicDescription': 'Lower Box 130',
        'code': 'LB130',
        'description': 'Lower Box 130'
      },
      {
        'id': '5878',
        'publicDescription': 'Lower Box 101',
        'code': 'LB101',
        'description': 'Lower Box 101'
      },
      {
        'id': '5903',
        'publicDescription': 'Lower Box 131',
        'code': 'LB131',
        'description': 'Lower Box 131'
      },
      {
        'id': '5724',
        'publicDescription': 'Lower Box 132',
        'code': 'LB132',
        'description': 'Lower Box 132'
      },
      {
        'id': '5880',
        'publicDescription': 'Lower Box 133',
        'code': 'LB133',
        'description': 'Lower Box 133'
      },
      {
        'id': '5756',
        'publicDescription': 'Lower Box 134',
        'code': 'LB134',
        'description': 'Lower Box 134'
      },
      {
        'id': '5790',
        'publicDescription': 'Lower Box 135',
        'code': 'LB135',
        'description': 'Lower Box 135'
      },
      {
        'id': '5950',
        'publicDescription': 'View Box VB315',
        'code': 'VB315',
        'description': 'View Box VB315'
      },
      {
        'id': '5897',
        'publicDescription': 'View Box VB317',
        'code': 'VB317',
        'description': 'View Box VB317'
      },
      {
        'id': '5916',
        'publicDescription': 'View Box VB314',
        'code': 'VB314',
        'description': 'View Box VB314'
      },
      {
        'id': '5723',
        'publicDescription': 'View Box VB318',
        'code': 'VB318',
        'description': 'View Box VB318'
      },
      {
        'id': '5836',
        'publicDescription': 'View Box VB313',
        'code': 'VB313',
        'description': 'View Box VB313'
      },
      {
        'id': '5910',
        'publicDescription': 'View Box VB319',
        'code': 'VB319',
        'description': 'View Box VB319'
      },
      {
        'id': '5721',
        'publicDescription': 'View Box VB312',
        'code': 'VB312',
        'description': 'View Box VB312'
      },
      {
        'id': '5771',
        'publicDescription': 'View Box VB320',
        'code': 'VB320',
        'description': 'View Box VB320'
      },
      {
        'id': '5762',
        'publicDescription': 'View Box VB311',
        'code': 'VB311',
        'description': 'View Box VB311'
      },
      {
        'id': '5697',
        'publicDescription': 'View Box VB321',
        'code': 'VB321',
        'description': 'View Box VB321'
      },
      {
        'id': '5725',
        'publicDescription': 'View Box VB310',
        'code': 'VB310',
        'description': 'View Box VB310'
      },
      {
        'id': '5777',
        'publicDescription': 'View Box VB323',
        'code': 'VB323',
        'description': 'View Box VB323'
      },
      {
        'id': '5707',
        'publicDescription': 'View Box VB308',
        'code': 'VB308',
        'description': 'View Box VB308'
      },
      {
        'id': '5812',
        'publicDescription': 'View Box VB324',
        'code': 'VB324',
        'description': 'View Box VB324'
      },
      {
        'id': '5883',
        'publicDescription': 'View Box VB307',
        'code': 'VB307',
        'description': 'View Box VB307'
      },
      {
        'id': '5816',
        'publicDescription': 'View Box VB325',
        'code': 'VB325',
        'description': 'View Box VB325'
      },
      {
        'id': '5802',
        'publicDescription': 'View Box VB305',
        'code': 'VB305',
        'description': 'View Box VB305'
      },
      {
        'id': '5843',
        'publicDescription': 'View Box VB326',
        'code': 'VB326',
        'description': 'View Box VB326'
      },
      {
        'id': '5957',
        'publicDescription': 'View Box VB327',
        'code': 'VB327',
        'description': 'View Box VB327'
      },
      {
        'id': '5908',
        'publicDescription': 'View Box VB328',
        'code': 'VB328',
        'description': 'View Box VB328'
      },
      {
        'id': '5906',
        'publicDescription': 'View Box VB330',
        'code': 'VB330',
        'description': 'View Box VB330'
      },
      {
        'id': '5911',
        'publicDescription': 'View Box VB304',
        'code': 'VB304',
        'description': 'View Box VB304'
      },
      {
        'id': '5769',
        'publicDescription': 'View Box VB302',
        'code': 'VB302',
        'description': 'View Box VB302'
      },
      {
        'id': '5747',
        'publicDescription': 'View Box VB331',
        'code': 'VB331',
        'description': 'View Box VB331'
      },
      {
        'id': '5781',
        'publicDescription': 'View Box VB332',
        'code': 'VB332',
        'description': 'View Box VB332'
      },
      {
        'id': '5870',
        'publicDescription': 'View Box VB334',
        'code': 'VB334',
        'description': 'View Box VB334'
      },
      {
        'id': '5764',
        'publicDescription': 'View Box VB335',
        'code': 'VB335',
        'description': 'View Box VB335'
      },
      {
        'id': '5782',
        'publicDescription': 'View Box VB336',
        'code': 'VB336',
        'description': 'View Box VB336'
      },
      {
        'id': '5951',
        'publicDescription': 'View Reserved 315',
        'code': 'VR315',
        'description': 'View Reserved 315'
      },
      {
        'id': '5731',
        'publicDescription': 'View Reserved 314',
        'code': 'VR314',
        'description': 'View Reserved 314'
      },
      {
        'id': '5798',
        'publicDescription': 'View Reserved 318',
        'code': 'VR318',
        'description': 'View Reserved 318'
      },
      {
        'id': '5822',
        'publicDescription': 'View Reserved 313',
        'code': 'VR313',
        'description': 'View Reserved 313'
      },
      {
        'id': '5882',
        'publicDescription': 'View Reserved 319',
        'code': 'VR319',
        'description': 'View Reserved 319'
      },
      {
        'id': '5695',
        'publicDescription': 'View Reserved 312',
        'code': 'VR312',
        'description': 'View Reserved 312'
      },
      {
        'id': '5727',
        'publicDescription': 'View Reserved 320',
        'code': 'VR320',
        'description': 'View Reserved 320'
      },
      {
        'id': '5915',
        'publicDescription': 'View Reserved 321',
        'code': 'VR321',
        'description': 'View Reserved 321'
      },
      {
        'id': '5765',
        'publicDescription': 'View Reserved 311',
        'code': 'VR311',
        'description': 'View Reserved 311'
      },
      {
        'id': '5770',
        'publicDescription': 'View Reserved 323',
        'code': 'VR323',
        'description': 'View Reserved 323'
      },
      {
        'id': '5809',
        'publicDescription': 'View Reserved 310',
        'code': 'VR310',
        'description': 'View Reserved 310'
      },
      {
        'id': '5835',
        'publicDescription': 'View Reserved 324',
        'code': 'VR324',
        'description': 'View Reserved 324'
      },
      {
        'id': '5874',
        'publicDescription': 'View Reserved 308',
        'code': 'VR308',
        'description': 'View Reserved 308'
      },
      {
        'id': '5709',
        'publicDescription': 'View Reserved 307',
        'code': 'VR307',
        'description': 'View Reserved 307'
      },
      {
        'id': '5775',
        'publicDescription': 'View Reserved 305',
        'code': 'VR305',
        'description': 'View Reserved 305'
      },
      {
        'id': '5828',
        'publicDescription': 'View Reserved 304',
        'code': 'VR304',
        'description': 'View Reserved 304'
      },
      {
        'id': '5875',
        'publicDescription': 'View Reserved 302',
        'code': 'VR302',
        'description': 'View Reserved 302'
      },
      {
        'id': '5837',
        'publicDescription': 'View Reserved 325',
        'code': 'VR325',
        'description': 'View Reserved 325'
      },
      {
        'id': '5912',
        'publicDescription': 'View Reserved 326',
        'code': 'VR326',
        'description': 'View Reserved 326'
      },
      {
        'id': '5873',
        'publicDescription': 'View Reserved 327',
        'code': 'VR327',
        'description': 'View Reserved 327'
      },
      {
        'id': '5936',
        'publicDescription': 'View Reserved 328',
        'code': 'VR328',
        'description': 'View Reserved 328'
      },
      {
        'id': '5871',
        'publicDescription': 'View Reserved 330',
        'code': 'VR330',
        'description': 'View Reserved 330'
      },
      {
        'id': '5748',
        'publicDescription': 'View Reserved 331',
        'code': 'VR331',
        'description': 'View Reserved 331'
      },
      {
        'id': '5856',
        'publicDescription': 'View Reserved 332',
        'code': 'VR332',
        'description': 'View Reserved 332'
      },
      {
        'id': '5700',
        'publicDescription': 'View Reserved 333',
        'code': 'VR333',
        'description': 'View Reserved 333'
      },
      {
        'id': '5930',
        'publicDescription': 'View Reserved 334',
        'code': 'VR334',
        'description': 'View Reserved 334'
      },
      {
        'id': '5926',
        'publicDescription': 'View Reserved 335',
        'code': 'VR335',
        'description': 'View Reserved 335'
      },
      {
        'id': '5917',
        'publicDescription': 'View Reserved 336',
        'code': 'VR336',
        'description': 'View Reserved 336'
      },
      {
        'id': '5959',
        'publicDescription': 'SalesForce Champions Suite',
        'code': 'CHAMP STE',
        'description': 'SalesForce Champions Suite'
      },
      {
        'id': '5885',
        'publicDescription': 'STE 1',
        'code': 'LS1',
        'description': 'Luxury Suite 1'
      },
      {
        'id': '5694',
        'publicDescription': 'STE 2',
        'code': 'LS2',
        'description': 'Luxury Suite 2'
      },
      {
        'id': '5742',
        'publicDescription': 'STE 3',
        'code': 'LS3',
        'description': 'Luxury Suite 3'
      },
      {
        'id': '5738',
        'publicDescription': 'STE 4',
        'code': 'LS4',
        'description': 'Luxury Suite 4'
      },
      {
        'id': '5933',
        'publicDescription': 'STE 5',
        'code': 'LS5',
        'description': 'Luxury Suite 5'
      },
      {
        'id': '5955',
        'publicDescription': 'STE 6',
        'code': 'LS6',
        'description': 'Luxury Suite 6'
      },
      {
        'id': '5737',
        'publicDescription': 'STE 7',
        'code': 'LS7',
        'description': 'Luxury Suite 7'
      },
      {
        'id': '5920',
        'publicDescription': 'STE 8',
        'code': 'LS8',
        'description': 'Luxury Suite 8'
      },
      {
        'id': '5703',
        'publicDescription': 'STE 9',
        'code': 'LS9',
        'description': 'Luxury Suite 9'
      },
      {
        'id': '5902',
        'publicDescription': 'STE 10',
        'code': 'LS10',
        'description': 'Luxury Suite 10'
      },
      {
        'id': '5958',
        'publicDescription': 'STE 11',
        'code': 'LS11',
        'description': 'Luxury Suite 11'
      },
      {
        'id': '5761',
        'publicDescription': 'STE 12',
        'code': 'LS12',
        'description': 'Luxury Suite 12'
      },
      {
        'id': '5726',
        'publicDescription': 'STE 13',
        'code': 'LS13',
        'description': 'Luxury Suite 13'
      },
      {
        'id': '5831',
        'publicDescription': 'STE 14',
        'code': 'LS14',
        'description': 'Luxury Suite 14'
      },
      {
        'id': '5857',
        'publicDescription': 'STE 15',
        'code': 'LS15',
        'description': 'Luxury Suite 15'
      },
      {
        'id': '5768',
        'publicDescription': 'STE 16',
        'code': 'LS16',
        'description': 'Luxury Suite 16'
      },
      {
        'id': '5793',
        'publicDescription': 'STE 17',
        'code': 'LS17',
        'description': 'Luxury Suite 17'
      },
      {
        'id': '5808',
        'publicDescription': 'STE 18',
        'code': 'LS18',
        'description': 'Luxury Suite 18'
      },
      {
        'id': '5868',
        'publicDescription': 'STE 19',
        'code': 'LS19',
        'description': 'Luxury Suite 19'
      },
      {
        'id': '5839',
        'publicDescription': 'STE 20',
        'code': 'LS20',
        'description': 'Luxury Suite 20'
      },
      {
        'id': '5838',
        'publicDescription': 'STE 21',
        'code': 'LS21',
        'description': 'Luxury Suite 21'
      },
      {
        'id': '5766',
        'publicDescription': 'STE 22',
        'code': 'LS22',
        'description': 'Luxury Suite 22'
      },
      {
        'id': '5797',
        'publicDescription': 'STE 23',
        'code': 'LS23',
        'description': 'Luxury Suite 23'
      },
      {
        'id': '5820',
        'publicDescription': 'STE 24',
        'code': 'LS24',
        'description': 'Luxury Suite 24'
      },
      {
        'id': '5795',
        'publicDescription': 'STE 25',
        'code': 'LS25',
        'description': 'Luxury Suite 25'
      },
      {
        'id': '5935',
        'publicDescription': 'STE 26',
        'code': 'LS26',
        'description': 'Luxury Suite 26'
      },
      {
        'id': '5889',
        'publicDescription': 'STE 27',
        'code': 'LS27',
        'description': 'Luxury Suite 27'
      },
      {
        'id': '5913',
        'publicDescription': 'STE 28',
        'code': 'LS28',
        'description': 'Luxury Suite 28'
      },
      {
        'id': '5891',
        'publicDescription': 'STE 29',
        'code': 'LS29',
        'description': 'Luxury Suite 29'
      },
      {
        'id': '5699',
        'publicDescription': 'STE 30',
        'code': 'LS30',
        'description': 'Luxury Suite 30'
      },
      {
        'id': '5783',
        'publicDescription': 'STE 31',
        'code': 'LS31',
        'description': 'Luxury Suite 31'
      },
      {
        'id': '5759',
        'publicDescription': 'STE 32',
        'code': 'LS32',
        'description': 'Luxury Suite 32'
      },
      {
        'id': '5751',
        'publicDescription': 'STE 33',
        'code': 'LS33',
        'description': 'Luxury Suite 33'
      },
      {
        'id': '5741',
        'publicDescription': 'STE 34',
        'code': 'LS34',
        'description': 'Luxury Suite 34'
      },
      {
        'id': '5745',
        'publicDescription': 'STE 35',
        'code': 'LS35',
        'description': 'Luxury Suite 35'
      },
      {
        'id': '5743',
        'publicDescription': 'STE 36',
        'code': 'LS36',
        'description': 'Luxury Suite 36'
      },
      {
        'id': '5773',
        'publicDescription': 'STE 37',
        'code': 'LS37',
        'description': 'Luxury Suite 37'
      },
      {
        'id': '5922',
        'publicDescription': 'STE 38',
        'code': 'LS38',
        'description': 'Luxury Suite 38'
      },
      {
        'id': '5701',
        'publicDescription': 'STE 39',
        'code': 'LS39',
        'description': 'Luxury Suite 39'
      },
      {
        'id': '5794',
        'publicDescription': 'STE 40',
        'code': 'LS40',
        'description': 'Luxury Suite 40'
      },
      {
        'id': '5767',
        'publicDescription': 'STE 41',
        'code': 'LS41',
        'description': 'Luxury Suite 41'
      },
      {
        'id': '5963',
        'publicDescription': 'STE 42',
        'code': 'LS42',
        'description': 'Luxury Suite 42'
      },
      {
        'id': '5789',
        'publicDescription': 'STE 43',
        'code': 'LS43',
        'description': 'Luxury Suite 43'
      },
      {
        'id': '5800',
        'publicDescription': 'STE 44',
        'code': 'LS44',
        'description': 'Luxury Suite 44'
      },
      {
        'id': '5876',
        'publicDescription': 'STE 45',
        'code': 'LS45',
        'description': 'Luxury Suite 45'
      },
      {
        'id': '5896',
        'publicDescription': 'STE 46',
        'code': 'LS46',
        'description': 'Luxury Suite 46'
      },
      {
        'id': '5863',
        'publicDescription': 'STE 47',
        'code': 'LS47',
        'description': 'Luxury Suite 47'
      },
      {
        'id': '5848',
        'publicDescription': 'STE 48',
        'code': 'LS48',
        'description': 'Luxury Suite 48'
      },
      {
        'id': '5931',
        'publicDescription': 'STE 49',
        'code': 'LS49',
        'description': 'Luxury Suite 49'
      },
      {
        'id': '5847',
        'publicDescription': 'STE 50',
        'code': 'LS50',
        'description': 'Luxury Suite 50'
      },
      {
        'id': '5722',
        'publicDescription': 'STE 51',
        'code': 'LS51',
        'description': 'Luxury Suite 51'
      },
      {
        'id': '5866',
        'publicDescription': 'STE 52',
        'code': 'LS52',
        'description': 'Luxury Suite 52'
      },
      {
        'id': '5732',
        'publicDescription': 'STE 53',
        'code': 'LS53',
        'description': 'Luxury Suite 53'
      },
      {
        'id': '5901',
        'publicDescription': 'STE 54',
        'code': 'LS54',
        'description': 'Luxury Suite 54'
      },
      {
        'id': '5784',
        'publicDescription': 'STE 55',
        'code': 'LS55',
        'description': 'Luxury Suite 55'
      },
      {
        'id': '5823',
        'publicDescription': 'STE 56',
        'code': 'LS56',
        'description': 'Luxury Suite 56'
      },
      {
        'id': '5854',
        'publicDescription': 'STE 57',
        'code': 'LS57',
        'description': 'Luxury Suite 57'
      },
      {
        'id': '5704',
        'publicDescription': 'STE 58',
        'code': 'LS58',
        'description': 'Luxury Suite 58'
      },
      {
        'id': '5818',
        'publicDescription': 'STE 59',
        'code': 'LS59',
        'description': 'Luxury Suite 59'
      },
      {
        'id': '5792',
        'publicDescription': 'STE 60',
        'code': 'LS60',
        'description': 'Luxury Suite 60'
      },
      {
        'id': '5740',
        'publicDescription': 'STE 61',
        'code': 'LS61',
        'description': 'Luxury Suite 61'
      },
      {
        'id': '5929',
        'publicDescription': 'STE 62',
        'code': 'LS62',
        'description': 'Luxury Suite 62'
      },
      {
        'id': '5895',
        'publicDescription': 'STE 63',
        'code': 'LS63',
        'description': 'Luxury Suite 63'
      },
      {
        'id': '5755',
        'publicDescription': 'STE 64',
        'code': 'LS64',
        'description': 'Luxury Suite 64'
      },
      {
        'id': '5752',
        'publicDescription': 'STE 65',
        'code': 'LS65',
        'description': 'Luxury Suite 65'
      },
      {
        'id': '5962',
        'publicDescription': 'STE 66',
        'code': 'LS66',
        'description': 'Luxury Suite 66'
      },
      {
        'id': '5872',
        'publicDescription': 'STE 67',
        'code': 'LS67',
        'description': 'Luxury Suite 67'
      },
      {
        'id': '5758',
        'publicDescription': 'Dugout Box',
        'code': 'DUG BOX',
        'description': 'Dugout Box'
      },
      {
        'id': '5785',
        'publicDescription': 'Corona Beach Club',
        'code': 'BP BOX',
        'description': 'Bullpen Box'
      },
      {
        'id': '5918',
        'publicDescription': 'Virgin America Loft',
        'code': 'VA LOFT',
        'description': 'Virgin America Loft'
      },
      {
        'id': '5851',
        'publicDescription': 'AUDI LEGENDS CLUB A8',
        'code': 'LEGENDS A',
        'description': 'AUDI LEGENDS CLUB A8'
      },
      {
        'id': '5954',
        'publicDescription': 'AUDI LEGENDS CLUB R8',
        'code': 'LEGENDS B',
        'description': 'AUDI LEGENDS CLUB R8'
      }
    ];
  }

  getSchedule() {
    this.schedules = {
      'numberOfEvents': 40,
      'gameEvents': [
        {
          'eventId': '9472',
          'eventCode': '20RS0408',
          'description': 'Braves at Zephyrs',
          'eventDateFull': '2020-04-08T19:35:00.000-04:00',
          'eventDateReadable': 'Apr 8, 2020 7:35:00 PM',
          'eventDate': 'Wednesday Apr 8, 2020',
          'eventTime': '7:35 PM'
        },
        {
          'eventId': '9473',
          'eventCode': '20RS0409',
          'description': 'Blue Jays at Zephyrs',
          'eventDateFull': '2020-04-09T19:35:00.000-04:00',
          'eventDateReadable': 'Apr 9, 2020 7:35:00 PM',
          'eventDate': 'Thursday Apr 9, 2020',
          'eventTime': '7:35 PM'
        },
        {
          'eventId': '9474',
          'eventCode': '20RS0410',
          'description': 'Blue Jays at Zephyrs',
          'eventDateFull': '2020-04-10T19:35:00.000-04:00',
          'eventDateReadable': 'Apr 10, 2020 7:35:00 PM',
          'eventDate': 'Friday Apr 10, 2020',
          'eventTime': '7:35 PM'
        },
        {
          'eventId': '9475',
          'eventCode': '20RS0422',
          'description': 'Blue Jays at Zephyrs',
          'eventDateFull': '2020-04-22T14:05:00.000-04:00',
          'eventDateReadable': 'Apr 22, 2020 2:05:00 PM',
          'eventDate': 'Wednesday Apr 22, 2020',
          'eventTime': '2:05 PM'
        },
        {
          'eventId': '9476',
          'eventCode': '20RS0423',
          'description': 'Red Sox at Zephyrs',
          'eventDateFull': '2020-04-23T19:35:00.000-04:00',
          'eventDateReadable': 'Apr 23, 2020 7:35:00 PM',
          'eventDate': 'Thursday Apr 23, 2020',
          'eventTime': '7:35 PM'
        },
        {
          'eventId': '9477',
          'eventCode': '20RS0424',
          'description': 'White Sox at Zephyrs',
          'eventDateFull': '2020-04-24T19:35:00.000-04:00',
          'eventDateReadable': 'Apr 24, 2020 7:35:00 PM',
          'eventDate': 'Friday Apr 24, 2020',
          'eventTime': '7:35 PM'
        },
        {
          'eventId': '9478',
          'eventCode': '20RS0504',
          'description': 'Reds at Zephyrs',
          'eventDateFull': '2020-05-04T19:35:00.000-04:00',
          'eventDateReadable': 'May 4, 2020 7:35:00 PM',
          'eventDate': 'Monday May 4, 2020',
          'eventTime': '7:35 PM'
        },
        {
          'eventId': '9479',
          'eventCode': '20RS0506',
          'description': 'Reds at Zephyrs',
          'eventDateFull': '2020-05-06T19:35:00.000-04:00',
          'eventDateReadable': 'May 6, 2020 7:35:00 PM',
          'eventDate': 'Wednesday May 6, 2020',
          'eventTime': '7:35 PM'
        },
        {
          'eventId': '9480',
          'eventCode': '20RS0507',
          'description': 'Cubs at Zephyrs',
          'eventDateFull': '2020-05-07T14:35:00.000-04:00',
          'eventDateReadable': 'May 7, 2020 2:35:00 PM',
          'eventDate': 'Thursday May 7, 2020',
          'eventTime': '2:35 PM'
        },
        {
          'eventId': '9481',
          'eventCode': '20RS0508',
          'description': 'Cubs at Zephyrs',
          'eventDateFull': '2020-05-08T19:35:00.000-04:00',
          'eventDateReadable': 'May 8, 2020 7:35:00 PM',
          'eventDate': 'Friday May 8, 2020',
          'eventTime': '7:35 PM'
        },
        {
          'eventId': '9482',
          'eventCode': '20RS0518',
          'description': 'Angels at Zephyrs',
          'eventDateFull': '2020-05-18T19:35:00.000-04:00',
          'eventDateReadable': 'May 18, 2020 7:35:00 PM',
          'eventDate': 'Monday May 18, 2020',
          'eventTime': '7:35 PM'
        },
        {
          'eventId': '9483',
          'eventCode': '20RS0520',
          'description': 'Angels at Zephyrs',
          'eventDateFull': '2020-05-20T19:35:00.000-04:00',
          'eventDateReadable': 'May 20, 2020 7:35:00 PM',
          'eventDate': 'Wednesday May 20, 2020',
          'eventTime': '7:35 PM'
        },
        {
          'eventId': '9484',
          'eventCode': '20RS0521',
          'description': 'Angels at Zephyrs',
          'eventDateFull': '2020-05-21T14:05:00.000-04:00',
          'eventDateReadable': 'May 21, 2020 2:05:00 PM',
          'eventDate': 'Thursday May 21, 2020',
          'eventTime': '2:05 PM'
        },
        {
          'eventId': '9485',
          'eventCode': '20RS0608',
          'description': 'Rockies at Zephyrs',
          'eventDateFull': '2020-06-08T19:35:00.000-04:00',
          'eventDateReadable': 'Jun 8, 2020 7:35:00 PM',
          'eventDate': 'Monday Jun 8, 2020',
          'eventTime': '7:35 PM'
        },
        {
          'eventId': '9486',
          'eventCode': '20RS0610',
          'description': 'Indians at Zephyrs',
          'eventDateFull': '2020-06-10T19:35:00.000-04:00',
          'eventDateReadable': 'Jun 10, 2020 7:35:00 PM',
          'eventDate': 'Wednesday Jun 10, 2020',
          'eventTime': '7:35 PM'
        },
        {
          'eventId': '9487',
          'eventCode': '20RS0611',
          'description': 'Indians at Zephyrs',
          'eventDateFull': '2020-06-11T19:35:00.000-04:00',
          'eventDateReadable': 'Jun 11, 2020 7:35:00 PM',
          'eventDate': 'Thursday Jun 11, 2020',
          'eventTime': '7:35 PM'
        },
        {
          'eventId': '9488',
          'eventCode': '20RS0612',
          'description': 'Indians at Zephyrs',
          'eventDateFull': '2020-06-12T19:35:00.000-04:00',
          'eventDateReadable': 'Jun 12, 2020 7:35:00 PM',
          'eventDate': 'Friday Jun 12, 2020',
          'eventTime': '7:35 PM'
        },
        {
          'eventId': '9489',
          'eventCode': '20RS0622',
          'description': 'Nationals at Zephyrs',
          'eventDateFull': '2020-06-22T14:35:00.000-04:00',
          'eventDateReadable': 'Jun 22, 2020 2:35:00 PM',
          'eventDate': 'Monday Jun 22, 2020',
          'eventTime': '2:35 PM'
        },
        {
          'eventId': '9490',
          'eventCode': '20RS0624',
          'description': 'Nationals at Zephyrs',
          'eventDateFull': '2020-06-24T19:35:00.000-04:00',
          'eventDateReadable': 'Jun 24, 2020 7:35:00 PM',
          'eventDate': 'Wednesday Jun 24, 2020',
          'eventTime': '7:35 PM'
        },
        {
          'eventId': '9491',
          'eventCode': '20RS0625',
          'description': 'Nationals at Zephyrs',
          'eventDateFull': '2020-06-25T19:35:00.000-04:00',
          'eventDateReadable': 'Jun 25, 2020 7:35:00 PM',
          'eventDate': 'Thursday Jun 25, 2020',
          'eventTime': '7:35 PM'
        },
        {
          'eventId': '9492',
          'eventCode': '20RS0626',
          'description': 'Astros at Zephyrs',
          'eventDateFull': '2020-06-26T14:05:00.000-04:00',
          'eventDateReadable': 'Jun 26, 2020 2:05:00 PM',
          'eventDate': 'Friday Jun 26, 2020',
          'eventTime': '2:05 PM'
        },
        {
          'eventId': '9493',
          'eventCode': '20RS0713',
          'description': 'Orioles at Zephyrs',
          'eventDateFull': '2020-07-13T19:35:00.000-04:00',
          'eventDateReadable': 'Jul 13, 2020 7:35:00 PM',
          'eventDate': 'Monday Jul 13, 2020',
          'eventTime': '7:35 PM'
        },
        {
          'eventId': '9494',
          'eventCode': '20RS0715',
          'description': 'Orioles at Zephyrs',
          'eventDateFull': '2020-07-15T14:35:00.000-04:00',
          'eventDateReadable': 'Jul 15, 2020 2:35:00 PM',
          'eventDate': 'Wednesday Jul 15, 2020',
          'eventTime': '2:35 PM'
        },
        {
          'eventId': '9495',
          'eventCode': '20RS0716',
          'description': 'Tigers at Zephyrs',
          'eventDateFull': '2020-07-16T14:05:00.000-04:00',
          'eventDateReadable': 'Jul 16, 2020 2:05:00 PM',
          'eventDate': 'Thursday Jul 16, 2020',
          'eventTime': '2:05 PM'
        },
        {
          'eventId': '9496',
          'eventCode': '20RS0717',
          'description': 'Tigers at Zephyrs',
          'eventDateFull': '2020-07-17T14:05:00.000-04:00',
          'eventDateReadable': 'Jul 17, 2020 2:05:00 PM',
          'eventDate': 'Friday Jul 17, 2020',
          'eventTime': '2:05 PM'
        },
        {
          'eventId': '9497',
          'eventCode': '20RS0729',
          'description': 'Royals at Zephyrs',
          'eventDateFull': '2020-07-29T19:35:00.000-04:00',
          'eventDateReadable': 'Jul 29, 2020 7:35:00 PM',
          'eventDate': 'Wednesday Jul 29, 2020',
          'eventTime': '7:35 PM'
        },
        {
          'eventId': '9498',
          'eventCode': '20RS0730',
          'description': 'Royals at Zephyrs',
          'eventDateFull': '2020-07-30T19:35:00.000-04:00',
          'eventDateReadable': 'Jul 30, 2020 7:35:00 PM',
          'eventDate': 'Thursday Jul 30, 2020',
          'eventTime': '7:35 PM'
        },
        {
          'eventId': '9499',
          'eventCode': '20RS0810',
          'description': 'Marlins at Zephyrs',
          'eventDateFull': '2020-08-10T14:05:00.000-04:00',
          'eventDateReadable': 'Aug 10, 2020 2:05:00 PM',
          'eventDate': 'Monday Aug 10, 2020',
          'eventTime': '2:05 PM'
        },
        {
          'eventId': '9500',
          'eventCode': '20RS0812',
          'description': 'Brewers at Zephyrs',
          'eventDateFull': '2020-08-12T19:35:00.000-04:00',
          'eventDateReadable': 'Aug 12, 2020 7:35:00 PM',
          'eventDate': 'Wednesday Aug 12, 2020',
          'eventTime': '7:35 PM'
        },
        {
          'eventId': '9501',
          'eventCode': '20RS0813',
          'description': 'Brewers at Zephyrs',
          'eventDateFull': '2020-08-13T19:35:00.000-04:00',
          'eventDateReadable': 'Aug 13, 2020 7:35:00 PM',
          'eventDate': 'Thursday Aug 13, 2020',
          'eventTime': '7:35 PM'
        },
        {
          'eventId': '9502',
          'eventCode': '20RS0824',
          'description': 'Twins at Zephyrs',
          'eventDateFull': '2020-08-24T19:35:00.000-04:00',
          'eventDateReadable': 'Aug 24, 2020 7:35:00 PM',
          'eventDate': 'Monday Aug 24, 2020',
          'eventTime': '7:35 PM'
        },
        {
          'eventId': '9503',
          'eventCode': '20RS0826',
          'description': 'Twins at Zephyrs',
          'eventDateFull': '2020-08-26T19:35:00.000-04:00',
          'eventDateReadable': 'Aug 26, 2020 7:35:00 PM',
          'eventDate': 'Wednesday Aug 26, 2020',
          'eventTime': '7:35 PM'
        },
        {
          'eventId': '9504',
          'eventCode': '20RS0827',
          'description': 'Twins at Zephyrs',
          'eventDateFull': '2020-08-27T19:35:00.000-04:00',
          'eventDateReadable': 'Aug 27, 2020 7:35:00 PM',
          'eventDate': 'Thursday Aug 27, 2020',
          'eventTime': '7:35 PM'
        },
        {
          'eventId': '9505',
          'eventCode': '20RS0910',
          'description': 'Brewers at Zephyrs',
          'eventDateFull': '2020-09-10T19:35:00.000-04:00',
          'eventDateReadable': 'Sep 10, 2020 7:35:00 PM',
          'eventDate': 'Thursday Sep 10, 2020',
          'eventTime': '7:35 PM'
        },
        {
          'eventId': '9506',
          'eventCode': '20RS0911',
          'description': 'Brewers at Zephyrs',
          'eventDateFull': '2020-09-11T19:35:00.000-04:00',
          'eventDateReadable': 'Sep 11, 2020 7:35:00 PM',
          'eventDate': 'Friday Sep 11, 2020',
          'eventTime': '7:35 PM'
        },
        {
          'eventId': '9507',
          'eventCode': '20RS0921',
          'description': 'Padres at Zephyrs',
          'eventDateFull': '2020-09-21T19:35:00.000-04:00',
          'eventDateReadable': 'Sep 21, 2020 7:35:00 PM',
          'eventDate': 'Monday Sep 21, 2020',
          'eventTime': '7:35 PM'
        },
        {
          'eventId': '9508',
          'eventCode': '20RS1001',
          'description': 'Mariners at Zephyrs',
          'eventDateFull': '2020-10-01T19:35:00.000-04:00',
          'eventDateReadable': 'Oct 1, 2020 7:35:00 PM',
          'eventDate': 'Thursday Oct 1, 2020',
          'eventTime': '7:35 PM'
        },
        {
          'eventId': '9509',
          'eventCode': '20RS1002',
          'description': 'Mets at Zephyrs',
          'eventDateFull': '2020-10-02T14:05:00.000-04:00',
          'eventDateReadable': 'Oct 2, 2020 2:05:00 PM',
          'eventDate': 'Friday Oct 2, 2020',
          'eventTime': '2:05 PM'
        },
        {
          'eventId': '9510',
          'eventCode': '20RS1005',
          'description': 'Mets at Zephyrs',
          'eventDateFull': '2020-10-05T19:35:00.000-04:00',
          'eventDateReadable': 'Oct 5, 2020 7:35:00 PM',
          'eventDate': 'Monday Oct 5, 2020',
          'eventTime': '7:35 PM'
        },
        {
          'eventId': '9511',
          'eventCode': '20RS1007',
          'description': 'Rangers at Zephyrs',
          'eventDateFull': '2020-10-07T19:35:00.000-04:00',
          'eventDateReadable': 'Oct 7, 2020 7:35:00 PM',
          'eventDate': 'Wednesday Oct 7, 2020',
          'eventTime': '7:35 PM'
        }
      ]
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/reusable/choose-seat-selection/choose-seat-selection.component.ts